// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e8c6cf08","455":"9577a470","977":"9ccfda1a"}[chunkId] + ".chunk.js";
};